<app-step [title]="'BASKET.TITLE' | translate"
          [description]="'BASKET.DESCRIPTION' | translate"
          [submit]="'CHECKOUT_STEP.TO_CUSTOMER_INFO' | translate"
          [link]="checkout?.checkoutPageLink"
          [backLink]="'/'"
          [backLinkText]="'BASKET.RETURN' | translate"
          [hide]="false"
          [disableButton]="basketQuantity$|async"
          >
    <!-- <app-usp></app-usp> -->

    <app-basket></app-basket>
</app-step>
<footer>
    <app-usp-bulk-element [layout]="checkout?.usp||[]"></app-usp-bulk-element>
</footer>
